/** @jsx h */
import { h } from 'preact'

const RightIcon = () => {
  return (
    <svg width='42' height='42' viewBox='0 0 42 42'>
      <g fill='none' fillRule='evenodd' stroke='currentColor'>
        <circle cx='20' cy='20' r='20' transform='matrix(0 1 1 0 1 1)' />
        <path strokeLinecap='round' d='M19.333 14.333L26 21l-6.667 6.667' />
      </g>
    </svg>
  )
}

export default RightIcon
